import React from "react";

import cx from "@/utils/cx";

const LinearProgress: React.FC<
  {
    progress: number;
    progressLabel?: string;
    secondaryLabel?: string;
    progressColor?: string;
    secondaryColor?: string;
  } & React.HTMLAttributes<HTMLDivElement>
> = ({
  progress,
  progressLabel,
  secondaryLabel,
  progressColor = "#000",
  secondaryColor = "#000",
  className,
  style,
  ...rest
}) => {
  return (
    <div
      className={cx(
        "relative w-full min-h-[28px] px-3 py-1 rounded-md overflow-hidden",
        className
      )}
      style={{
        ...style,
        background: secondaryColor,
      }}
      {...rest}
    >
      <span
        className="absolute top-0 left-0 h-full rounded-md"
        style={{
          width: `${progress}%`,
          background: progressColor,
        }}
      />
      <div className="z-10 relative flex justify-between items-center w-full h-full">
        {progressLabel ? (
          <small className="text-sm font-semibold">{progressLabel}</small>
        ) : null}
        {secondaryLabel ? (
          <small className="text-sm font-semibold">{secondaryLabel}</small>
        ) : null}
      </div>
    </div>
  );
};

export default LinearProgress;
